import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const usePageSidebarStyles = makeStyles(({ spacing }) =>
  createStyles({
    sidebarWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: `calc(100% - ${spacing(4)})`,
      minWidth: 390,
      maxWidth: '42vw',
      margin: `${spacing(2)} 0 0 ${spacing(2)}`,
      '@media (max-width: 768px)': {
        paddingRight: spacing(4),
      },
    },
    search: {
      marginBottom: spacing(8),
    },
  })
);

export default usePageSidebarStyles;
